



















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {HomePartner} from '@/models/home-partner';
import {TimelineMax} from 'gsap';
import {i18nModule} from '@/utils/store-acessor';
import {LocaleSelectorType} from '@/store/i18n.store.module';

@Component({})
export default class HomePartnerDetail extends Vue {
  @i18nModule.Getter('locale') locale!: LocaleSelectorType;

  @Prop({required: true}) partner!: HomePartner;

  displayPartner: HomePartner = this.partner;

  @Watch('partner')
  animate() {
    const {itemImg, itemText} = this.$refs;

    const tl0 = new TimelineMax();
    tl0
            .to(itemImg, 0.25, {x: -200, opacity: 0, onComplete: this.changeText})
            .to(itemImg, 0.5, {x: 0, opacity: 1});

    const tl1 = new TimelineMax();
    tl1
            .to(itemText, 0.25, {x: 200, opacity: 0})
            .to(itemText, 0.5, {x: 0, opacity: 1});
  }

  get name(): string {
    const locale = this.locale.value;
    switch (locale) {
      case 'en':
        return this.partner?.name?.en || '';
      case 'ptBr':
        return this.partner?.name?.pt || '';
    }
  }

  get description(): string {
    const locale = this.locale.value;
    switch (locale) {
      case 'ptBr':
        return this.partner?.description?.pt || '';
      case 'en':
        return this.partner?.description?.en || '';
    }
  }

  private changeText() {
    this.displayPartner = this.partner;
  }
}
